import { useEffect, useState } from "react";

const getUsuarioInterno = () => {
  try {
    const data = localStorage.getItem("user");
    if (!data) return null;
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
};

// Verifica se o usuário é um administrador
const checkAdministrador = (result) => {
  // Verifica se a propriedade rlPermissoesUsuario existe e é um array
  if (!Array.isArray(result?.usuario?.rlPermissoesUsuario)) return false;

  // Itera sobre o array para verificar se algum objeto contém a propriedade
  // codigoPermissao com valor "ADM"
  return result.usuario.rlPermissoesUsuario.some(
    (permissao) =>
      permissao?.permissao?.codigoPermissao?.toUpperCase() === "ADM",
  );
};

/**
 * Permissões de rota do console interno, no mesmo formato do
 * `pages/client/layout/usePermissoesRotasCliente`.
 *
 * Diferença de origem (mantida como está): aqui o mapa de rotas e o flag de ADM
 * chegam prontos do `App.js` (`routesPermissao` / `admPermissao`); o hook só
 * resolve o `administrador` a partir do usuário salvo no `localStorage` e expõe
 * o helper de leitura usado pelo menu lateral.
 */
export default function usePermissoesRotasInterno({
  routesPermissao = {},
  admPermissao = false,
} = {}) {
  const [administrador, setAdministrador] = useState(false);

  useEffect(() => {
    setAdministrador(checkAdministrador(getUsuarioInterno()));
  }, []);

  // Rota liberada pela permissão do usuário (ADM enxerga tudo)
  const podeVer = (path) => admPermissao || !!routesPermissao[path];

  return { administrador, podeVer };
}
